module.exports = __webpack_public_path__ + "img/chevron-left-white.436a8905.svg";